import React from "react";

const HandBurgerIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
<path d="M8.3251 0.223731C8.01914 -0.0777291 7.52673 -0.0740825 7.22527 0.231876C6.92381 0.537834 6.92746 1.03024 7.23341 1.3317L11.41 5.44691L0.777717 5.44691C0.348195 5.44691 0 5.79511 0 6.22463C0 6.65415 0.348196 7.00235 0.777717 7.00235L11.4049 7.00235L7.23341 11.1125C6.92746 11.414 6.92381 11.9064 7.22527 12.2123C7.52673 12.5183 8.01914 12.5219 8.3251 12.2205L13.7102 6.91458C14.0966 6.5338 14.0966 5.91039 13.7102 5.52961L8.3251 0.223731Z" fill="#818181"/>
</svg>
  );
};

export default HandBurgerIcon;
